// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const faqData = [
//   {
//     id: "collapseOne",
//     question: "Question number 01",
//     answer: (
//       <>
//         <p>
//           Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel ornare tellus.
//           Sed quis diam ullamcorper ante eleifend efficitur ac quis lectus.
//         </p>
//         <p>
//           Ut et pretium felis. Cras in dui nisi. Sed iaculis blandit sagittis.
//           Duis nec ipsum tristique, fringilla tellus a, varius arcu.
//         </p>
//       </>
//     ),
//   },
//   {
//     id: "collapseTwo",
//     question: "Question number 02",
//     answer: (
//       <p>
//         Ut et pretium felis. Cras in dui nisi. Sed iaculis blandit sagittis. Duis nec ipsum
//         tristique, fringilla tellus a, varius arcu. Nullam auctor metus eu felis egestas.
//       </p>
//     ),
//   },
//   {
//     id: "collapseThree",
//     question: "Question number 03",
//     answer: (
//       <p>
//         Suspendisse laoreet lectus quis orci porta tempus. Proin eu consequat massa.
//         Proin nec libero a ligula consequat placerat non non nisl.
//       </p>
//     ),
//   },
//   {
//     id: "collapseFour",
//     question: "Question number 04",
//     answer: (
//       <p>
//         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ipsum mi, dictum vitae
//         nibh in, ultricies commodo metus.
//       </p>
//     ),
//   },
// ];

// const FaqContainer = () => {
//   const [openId, setOpenId] = useState("collapseTwo"); // default open (like your isOpen)

//   useEffect(() => {
//     AOS.init({ once: true });
//   }, []);

//   const toggleAccordion = (id) => {
//     setOpenId(openId === id ? null : id);
//   };

//   return (
//     <section className="faqcontainer">
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <div
//               className="section-heading text-center"
//               data-aos="zoom-in"
//               data-aos-duration="1000"
//             >
//               <h2>
//                 Frequently <br /> Asked Questions
//               </h2>
//             </div>
//           </div>
//         </div>

//         <div className="row justify-content-center" data-aos="fade-up" data-aos-duration="800">
//           <div className="col-xxl-10 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
//             <div className="accordion" id="accordionExample">
//               {faqData.map((faq) => (
//                 <div className="accordion-item" key={faq.id}>
//                   <h2 className="accordion-header">
//                     <button
//                       className={`accordion-button ${openId === faq.id ? "" : "collapsed"}`}
//                       type="button"
//                       onClick={() => toggleAccordion(faq.id)}
//                       aria-expanded={openId === faq.id}
//                       aria-controls={faq.id}
//                     >
//                       {faq.question}
                     
//                     </button>
//                   </h2>
//                   <div
//                     id={faq.id}
//                     className={`accordion-collapse collapse ${openId === faq.id ? "show" : ""}`}
//                   >
//                     <div className="accordion-body">{faq.answer}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FaqContainer;


import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import API_BASE_URL from "../../src/config";

const FaqContainer = () => {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null); // default: no open

  useEffect(() => {
    AOS.init({ once: true });

    // Fetch FAQ data from API
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}home`); //  
        if (response.data.success && response.data.data.faqs) {
          setFaqs(response.data.data.faqs);
          if (response.data.data.faqs.length > 0) {
            setOpenId(response.data.data.faqs[0].id); // open first FAQ by default
          }
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, []);

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="faqcontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="section-heading text-center"
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              <h2>
                Frequently <br /> Asked Questions
              </h2>
            </div>
          </div>
        </div>

        <div
          className="row justify-content-center"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div className="col-xxl-10 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="accordion" id="accordionExample">
              {faqs.map((faq) => (
                <div className="accordion-item" key={faq.id}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        openId === faq.id ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(faq.id)}
                      aria-expanded={openId === faq.id}
                      aria-controls={`collapse-${faq.id}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${faq.id}`}
                    className={`accordion-collapse collapse ${
                      openId === faq.id ? "show" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}

              {faqs.length === 0 && (
                <div className="text-center py-4">No FAQs available.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqContainer;
